import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

import { calculateVolume } from "@/main/services/utilsNumber";
import { PackageTypeResponse } from "@/main/models/response";

import { getTranslateByKey } from "@/main/services/utils";
import * as S from "./styles";

interface IListItemDragAndDrop {
	packageTypeData: PackageTypeResponse[];
	setPackageTypeData: React.Dispatch<React.SetStateAction<PackageTypeResponse[] | null>>;
	buttonDelete: (guidPackageType: string) => void;
	buttonEdit: (guidPackageType: string, guidCountry: string) => void;
}
function ListItemDragAndDrop({ packageTypeData, setPackageTypeData, buttonDelete, buttonEdit }: IListItemDragAndDrop) {
	const currentIndex = React.useRef<number | undefined>(undefined);
	function dragStart(ev: React.DragEvent<HTMLElement>) {
		const el = ev.currentTarget as HTMLElement;
		el.style.opacity = "0.1";
		currentIndex.current = Number(el.getAttribute("data-index"));
		ev.dataTransfer.setData("text/html", ev.target);
		ev.dataTransfer.dropEffect = "move";
	}

	function dragEnd(ev: React.DragEvent<HTMLElement>) {
		const el = ev.target as HTMLElement;
		el.style.opacity = "1";
	}

	function dragEnter(ev: React.DragEvent<HTMLElement>) {
		const element = ev.target as HTMLElement;
		const el = ev.currentTarget as HTMLElement;
		const index = Number(el.getAttribute("data-index"));
		if (currentIndex.current !== undefined && currentIndex.current < index) {
			element.classList.add("after-listItemDragAndDrop");
		} else if (currentIndex.current !== undefined && currentIndex.current > index) {
			element.classList.add("before-listItemDragAndDrop");
		}
	}

	function dragOver(ev: React.DragEvent<HTMLElement>) {
		ev.preventDefault();
		ev.dataTransfer.dropEffect = "move";
	}

	function dragLeave(ev: React.DragEvent<HTMLElement>) {
		const element = ev.target as HTMLElement;
		const el = ev.currentTarget as HTMLElement;
		const index = Number(el.getAttribute("data-index"));
		if (currentIndex.current !== undefined && currentIndex.current <= index) {
			element.classList.remove("after-listItemDragAndDrop");
		} else if (currentIndex.current !== undefined && currentIndex.current > index) {
			element.classList.remove("before-listItemDragAndDrop");
		}
	}

	function drop(ev: React.DragEvent<HTMLElement>) {
		ev.preventDefault();
		const element = ev.target as HTMLElement;
		const el = ev.currentTarget as HTMLElement;
		let index = Number(el.getAttribute("data-index"));
		const tempData = [...packageTypeData];
		element.classList.remove("before-listItemDragAndDrop", "after-listItemDragAndDrop");
		if (currentIndex.current !== undefined) {
			if (isNaN(index)) {
				index = currentIndex.current;
			}
			if (currentIndex.current < index) {
				tempData.splice(index + 1, 0, tempData[currentIndex.current]);
				tempData.splice(currentIndex.current, 1);
			}
			if (currentIndex.current > index) {
				tempData.splice(index, 0, tempData[currentIndex.current]);
				tempData.splice(currentIndex.current + 1, 1);
			}

			tempData.forEach((item, i) => {
				if (i >= index) {
					item.importance = i + 1;
				} else {
					item.importance = i;
				}
			});
			setPackageTypeData(tempData);
		}
	}

	return (
		<S.Container>
			{packageTypeData.map((item, index) => {
				return (
					<S.RowItem key={item.guid}>
						<S.PositionList>{index + 1}°</S.PositionList>
						<S.Item>
							<S.ItemGrab
								data-index={index}
								draggable
								onDragStart={dragStart}
								onDragEnd={dragEnd}
								onDragEnter={dragEnter}
								onDragOver={dragOver}
								onDragLeave={dragLeave}
								onDrop={drop}
							>
								<S.Title title={item.name}>{item.name}</S.Title>
								{}
								<S.Text
									title={
										item.packageTypeExceptionResponse && item.packageTypeExceptionResponse.length > 0
											? `${getTranslateByKey("information.itDoesNotConsolidateWithCategories")} ${item.packageTypeExceptionResponse.map(
													(category, index) => `${index === 0 ? "" : " "}${category.name}`,
												)}`
											: ``
									}
								>
									{item.packageTypeExceptionResponse && item.packageTypeExceptionResponse.length > 0 && (
										<>
											{getTranslateByKey("information.itDoesNotConsolidateWithCategories")}{" "}
											{item.packageTypeExceptionResponse.map(
												(category, index) =>
													`${category.name}${item.packageTypeExceptionResponse.length - 1 === index ? "" : ", "}`,
											)}
										</>
									)}
								</S.Text>

								<S.Text
									title={`${getTranslateByKey("information.maximumVolume")} ${calculateVolume(item.height, item.width, item.depth)} L`}
								>
									{getTranslateByKey("information.maximumVolume")}{" "}
									{calculateVolume(item.height, item.width, item.depth)} L
								</S.Text>
							</S.ItemGrab>
							<S.AreaButton>
								<S.ButtonEditIcon
									aria-label={getTranslateByKey("information.edit")}
									onClick={() => buttonEdit(item.guid, item.guidCountry)}
									id={`id-packWorkflow-button-edit-${item.name}`}
								>
									<EditIcon />
								</S.ButtonEditIcon>
								<S.ButtonCloseIcon
									aria-label={getTranslateByKey("information.deleted")}
									onClick={() => buttonDelete(item.guid)}
									id={`id-packWorkflow-button-delete-${item.name}`}
								>
									<CloseIcon />
								</S.ButtonCloseIcon>
							</S.AreaButton>
						</S.Item>
					</S.RowItem>
				);
			})}
		</S.Container>
	);
}

export default ListItemDragAndDrop;
